import moment from "moment";

export const displayDateWithTime = (value: string, at?: string | null): string => {
  return `${moment(value).format("DD MMM YYYY")}${at ? ` ${at}` : ","} ${moment(value).format("HH:mm")}`;
};
